import axios from 'axios';
import { Authentication } from '@icabbi/vue-authentication';

const defaultState = {
  onboardingApiServiceClient: null,
  appSigningInProgress: false,
};

const getters = {
  appSigningInProgress: state => state.appSigningInProgress,
  onboardingApiServiceClient: (state, contextGetters, rootState, rootGetters) => ({ dispatch }) => {
    const authentication = Authentication({ dispatch, getters: rootGetters });
    const { authenticationFailureInterceptor, bearerTokenInterceptor } = authentication;
    if (state.onboardingApiServiceClient === null) {
      state.onboardingApiServiceClient = axios.create({
        baseURL: process.env.VUE_APP_ONBOARDING_SERVICE_BASE_URL,
        timeout: 30000,
      });
      state.onboardingApiServiceClient.interceptors.response.use(
        undefined, error => authenticationFailureInterceptor(error),
      );
      state.onboardingApiServiceClient.interceptors.request.use(
        config => bearerTokenInterceptor(config),
      );
    }
    return state.onboardingApiServiceClient;
  },
};

const actions = {
  async uploadAndroidKeystore(context, { bookingChannelId, appSigning, throwFail = false }) {
    try {
      context.commit('setAppSigningInProgress', true);
      await context.getters.onboardingApiServiceClient(context)
        .post('/onboard/appsigning', { bookingChannelId, appSigning });
      context.dispatch(
        'globalMessages/addSuccess',
        { message: 'onboarding.appSigningUploadSuccess' },
        { root: true },
      );
    } catch (error) {
      context.dispatch(
        'globalMessages/addError',
        { message: 'onboarding.appSigningUploadError', error },
        { root: true },
      );

      if (throwFail === true) {
        throw error;
      }
    } finally {
      context.commit('setAppSigningInProgress', false);
    }
  },
  async generateAndroidKeystore(context, { bookingChannelId, throwFail = false }) {
    try {
      context.commit('setAppSigningInProgress', true);
      await context.getters.onboardingApiServiceClient(context)
        .post(`/booking-channel/${bookingChannelId}/android-signing/generate`);
      context.dispatch(
        'globalMessages/addSuccess',
        { message: 'onboarding.appSigningGenerationSuccess' },
        { root: true },
      );
    } catch (error) {
      context.dispatch(
        'globalMessages/addError',
        { message: 'onboarding.appSigningGenerationError', error },
        { root: true },
      );
      if (throwFail === true) {
        throw error;
      }
    } finally {
      context.commit('setAppSigningInProgress', false);
    }
  },
};

const mutations = {
  setAppSigningInProgress(state, appSigningInProgress) {
    state.appSigningInProgress = appSigningInProgress;
  },
};

export default {
  namespaced: true,
  state: defaultState,
  getters,
  actions,
  mutations,
};
